import * as Yup from 'yup'
const MAX_WORDS = 2000;
const MIN_WORDS = 50;

export const BasicDetailsSchema = (NonumberRequired)=> Yup.object({ 
    job_title:Yup.string().required("INPUT.VALIDATION.JOBPOST.JOB.TITLE"),
    employment_type:Yup.array().min(1, 'INPUT.VALIDATION.JOBPOST.EMPLOYMENT.TYPE'),
    job_type:Yup.array().min(1, 'INPUT.VALIDATION.JOBPOST.JOBTYPE'),
    schedule:Yup.array().min(1, 'INPUT.VALIDATION.JOBPOST.SCHEDULE'),
    start_date:Yup.date().required('INPUT.VALIDATION.JOBPOST.STARTDATE'),
    show_pay_by:Yup.string().required('INPUT.VALIDATION.JOBPOST.SHOWPAYBY'),    
    min_amount : Yup.number().min(1, "INPUT.VALIDATION.MINAMOUNT.POSITIVE").when("show_pay_by", {
    is: (val) => val === "Range" || val === "Starting amount",
    then: (schema) =>
      schema.required("INPUT.VALIDATION.MINAMOUNT.POSITIVE"),
    otherwise: (schema) => schema.notRequired()
  }),
    max_amount : Yup.number().min(1, "INPUT.VALIDATION.MAXAMOUNT.POSITIVE").when("show_pay_by", {
    is: (val) => val === "Range" || val === "Maximum amount",
    then: (schema) =>
      schema.required("INPUT.VALIDATION.MAXAMOUNT.POSITIVE"),
    otherwise: (schema) => schema.notRequired()
  })
    .test('is-greater', 'INPUT.VALIDATION.MAXAMOUNT.MAXAMOUNT', function(value) {
        const { min_amount } = this.parent;
        if(min_amount === null || min_amount === undefined){
          return true
        }
        if (value === null || value === undefined) {
          return true;
        }
        return value > min_amount;
      }),
    exact_amount : Yup.number().min(1, "INPUT.VALIDATION.EXACTAMOUNT.POSITIVE").when("show_pay_by", {
    is: "Exact amount",
    then: (schema) =>
      schema.required("INPUT.VALIDATION.EXACTAMOUNT.POSITIVE"),
    otherwise: (schema) => schema.notRequired()
  }),
    rate:Yup.string(),
    benefits:Yup.array(),
    job_description:Yup.string().required('INPUT.VALIDATION.JOBPOST.DESCRIPTION')
    // .test(
    //   'word-count',
    //   `INPUT.VALIDATION.DESCRIPTION.COUNT`,
    //   value => {
    //     if (!value) return false;
    //     const wordCount = value.trim().split(/\s+/).length;
    //     return wordCount >= MIN_WORDS && wordCount <= MAX_WORDS;
    //   }
    // )
    ,
     application_call_mobile_number:  Yup.string()
      .nullable()
      .test(
        "required-based-on-flag",
        "INPUT.VALIDATION.JOBPOST.APPLICATION.CALL",
        function (value) {
          if (NonumberRequired === false && !value) return false;
          return true;
        }
      ),
    require_resume:Yup.bool().required("INPUT.VALIDATION.JOBPOST.REQUIRE.RESUME"),
    notifications:Yup.bool().required("INPUT.VALIDATION.JOBPOST.NOTIFICATION"),

    require_certification_training: Yup.bool(),
    certifications: Yup.array().of(Yup.string()),
    trainings: Yup.array().of(Yup.string()),
}).test(
  "required-training-certification-selection",
  "INPUT.VALIDATION.TRAINING.SELECTION",
  function (values) {
    if (!values?.require_certification_training) return true;
    const certifications = Array.isArray(values?.certifications) ? values?.certifications : [];
    const trainings = Array.isArray(values?.trainings) ? values?.trainings : [];
    if (certifications.length > 0 || trainings.length > 0) return true;
    return this.createError({ path: "certifications" });
  },
)
